// ============================================================
// IZHUB Cleaning — Site Configuration
// Edit these values directly to update contact info, links,
// and the quote-form email service. No coding needed elsewhere.
// ============================================================

export const SITE = {
  // Primary business email (where quotes are delivered)
  contactEmail: "info@izhubcleaning.uk",
  // Replies to quote emails will land here (via reply-to)
  replyToEmail: "izhubclean@gmail.com",
  phone: "+447763933920",

  // Business address (shown on contact page, footer and in search results)
  addressLine: "Talavera Way, Tidworth, SP9 7WH",
  addressStreet: "Talavera Way",
  addressTown: "Tidworth",
  addressPostcode: "SP9 7WH",
  mapsEmbedQuery: "Talavera+Way,+Tidworth,+SP9+7WH",

  // Opening / response hours
  openingHours: "Monday to Saturday, 8:00am – 6:00pm",

  phoneDisplay: "07763 933 920",
  // WhatsApp keeps the original business number (0786 9165 458) even though
  // the number shown on the site is 07763 933 920.
  whatsappBusinessNumber: "+447869165458",
  whatsapp: "https://wa.me/447869165458?text=Hi%2C%20I%27d%20like%20to%20enquire%20about%20your%20cleaning%20services.",

  // ---------- Automatic WhatsApp quote delivery (Twilio) ----------
  // Disabled: the Twilio account has no WhatsApp sender number registered,
  // so every send failed (error 63031). To re-enable, register a WhatsApp
  // sender in Twilio that is DIFFERENT from the business mobile and paste
  // its number here in E.164 format, e.g. "+447763933920".
  whatsappSenderNumber: "",
  // Twilio Content API template SID for the approved "new quote request"
  // template. Leave empty until Meta approves the template in Twilio;
  // while empty, quotes are sent as plain WhatsApp text (works once the
  // sender is live, and inside the 24-hour customer service window).
  whatsappTemplateContentSid: "",

  // Social media profiles
  facebook: "https://facebook.com/izhubcleaning",
  instagram: "https://www.instagram.com/izhubcleaning?igsh=MTNtNGlleG0wdnhnNg==",

  // Cleaner portal link — used on the "Join as a Cleaner" page and in the footer.
  cleanerPortalUrl: "https://izhubcleaninghub.uk",

  // Google Business Profile (shown in footer + reviews section)
  googleBusinessUrl:
    "https://www.google.com/maps/place/IZHUB+Cleaning+Service/@51.160456,-1.6642579,15z/data=!4m6!3m5!1s0xaa0d05ebd417799d:0x4b6d9fef3026d0a4!8m2!3d51.160456!4d-1.6642579!16s%2Fg%2F11z308wqpq",
  googleReviewUrl:
    "https://search.google.com/local/writereview?placeid=ChIJnXkX1OsFDaoRpNAmMO-fbUs",

  // ---------- Quote form backend ----------
  // Free tier: 250 submissions/month. Sign up at https://web3forms.com
  // (enter info@izhubcleaning.uk, they email you an access key), then
  // paste the access key here. Submissions are emailed automatically
  // to the address you signed up with (info@izhubcleaning.uk).
  //
  // Until this is set, the form falls back to opening the user's email
  // client with a pre-filled draft (mailto).
  web3formsAccessKey: "e08dc85e-3646-4aa0-b3cf-32b558b4f9ec" as string,
};
